import { lazy, Suspense } from 'react';
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTop from "./components/feature/ScrollToTop";

// Lazy load non-critical UI overlays to reduce initial bundle
const WhatsAppButton = lazy(() => import("./components/feature/WhatsAppButton"));
const ExitIntentPopup = lazy(() => import("./pages/simulador/components/ExitIntentPopup"));
const CookieBanner = lazy(() => import("./components/feature/CookieBanner"));

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <AppRoutes />
        <Suspense fallback={null}>
          <WhatsAppButton />
          <ExitIntentPopup />
          <CookieBanner />
        </Suspense>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
